import React from 'react';

/** One label/value pair on the mono grid. The layout of every detail and editor screen. */
export function FieldRow({ label, children, labelWidth = 74, divider = true, style }) {
  return (
    <div style={{
      display: 'grid', gridTemplateColumns: `${labelWidth}px 1fr`, gap: '0 var(--bujo-space-3)',
      borderBottom: divider ? '1px solid var(--bujo-rule-hairline)' : 'none', ...style
    }}>
      <div style={{
        padding: 'var(--bujo-space-4) 0',
        font: `var(--bujo-fw-regular) var(--bujo-fs-label)/var(--bujo-lh-row) var(--bujo-font-mono)`,
        letterSpacing: 'var(--bujo-ls-label)', color: 'var(--bujo-text-meta)'
      }}>{label}</div>
      <div style={{
        padding: 'var(--bujo-space-4) 0', minHeight: 'var(--bujo-row-min)', boxSizing: 'border-box',
        font: 'var(--bujo-fw-regular) 13px/var(--bujo-lh-row) var(--bujo-font-mono)',
        color: 'var(--bujo-text-primary)'
      }}>{children}</div>
    </div>
  );
}
